import {
  GridSkeletonCard,
  GridSkeletonContent,
  GridSkeletonImage,
  ListSkeletonCard,
  ListSkeletonContent,
  ListSkeletonFooter,
  ListSkeletonImage,
  SkeletonLine,
} from './SkeletonCard.styles';
import type { SkeletonCardProps } from './SkeletonCard.types';

export function SkeletonCard({ variant = 'grid' }: SkeletonCardProps) {
  if (variant === 'list') {
    return (
      <ListSkeletonCard aria-hidden="true">
        <ListSkeletonImage />
        <ListSkeletonContent>
          <SkeletonLine $width="60%" $height="18px" />
          <SkeletonLine $width="40%" />
          <SkeletonLine $width="90%" />
          <ListSkeletonFooter>
            <SkeletonLine $width="80px" $height="16px" />
            <SkeletonLine $width="80px" $height="32px" />
          </ListSkeletonFooter>
        </ListSkeletonContent>
      </ListSkeletonCard>
    );
  }

  return (
    <GridSkeletonCard aria-hidden="true">
      <GridSkeletonImage />
      <GridSkeletonContent>
        <SkeletonLine $width="70%" $height="18px" />
        <SkeletonLine $width="45%" />
        <SkeletonLine $width="35%" $height="16px" />
      </GridSkeletonContent>
    </GridSkeletonCard>
  );
}
